import React from 'react'
import { Flex, Text, Box } from '@chatterbug/aaron'

import Bar from './Bar/Bar'

export const HEIGHTS = {
  thin: '6px',
  thick: '8px',
}

export type BarHeights = keyof typeof HEIGHTS

export const COMMON_PROPS = {
  borderRadius: '1x',
}
export interface ProgressBarProps {
  animateCompletion?: boolean
  completeFraction: number
  label?: string
  customWidth?: string
  size?: BarHeights
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  animateCompletion,
  completeFraction,
  label,
  customWidth = '144px',
  size = 'thin',
}) => {
  return (
    <Flex alignItems="center" flex={1}>
      {label && (
        <Text
          fontSize="xxs"
          color="gray60"
          mr="2x"
          sx={{ whiteSpace: 'nowrap' }}
        >
          {label}
        </Text>
      )}
      <Box
        // To help vertical align with the text
        mt="0,5x"
        // on mobile PB should take all available rest width of the parent, on bigger screens it's fixed width
        flex={{ _: '1', tablet: 'none' }}
        width={{ _: '0', tablet: customWidth }}
        height={HEIGHTS[size]}
        backgroundColor="gray88"
        role="img"
        aria-label={`${completeFraction}%`}
        {...COMMON_PROPS}
      >
        <Bar
          size={size}
          animateCompletion={animateCompletion}
          completeFraction={completeFraction}
        />
      </Box>
    </Flex>
  )
}

export default ProgressBar
